import Schema from 'AppReact/schema';
import { priority, inspection_tag, property, group } from 'types';

export default {
  tag: Schema(inspection_tag, 'object', { defaultValue: { text: '', color: '' } }),
  value: Schema('string', 'primitive', { defaultValue: '' }),
  color: Schema('string', 'primitive', { defaultValue: '' }),
  maxLength: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  editingField: Schema('string', 'primitive-nullable', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  priorities: Schema(priority, 'array', { defaultValue: [] }),
  priority_id: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  property_ids: Schema('integer', 'array', { defaultValue: [] }),
  group_ids: Schema('integer', 'array', { defaultValue: [] }),
  auto_add_new_properties: Schema('boolean', 'primitive', { defaultValue: false }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] })
}
